<ng-container *ngIf="error()">
  <ai-chat-message [message]="error()">
    <div class="retry-btn-wrapper">
      <q9-primary-button
        color="primary"
        [disabled]="isRunInProgress()"
        (click)="regenerateConversation()">
        {{ 'Retry' | translate }}
      </q9-primary-button>
    </div>
  </ai-chat-message>
</ng-container>
